module.exports = require("string_decoder");


//////////////////
// WEBPACK FOOTER
// external "string_decoder"
// module id = 524
// module chunks = 0 1 3